export const pages = {
  auth: {
    login: {
      title: 'Вхід'
    },
    confirmation: {
      title: 'Підтвердження допису',
      description:
        'Ми надіслали вам лист із кодом поштою {email}. Відправлення може зайняти до однієї хвилини'
    },
    verifyEmail: {
      title: 'Зміна пароля'
    },
    reset: {
      title: 'Зміна пароля'
    },
    otp: {
      title: 'Підтвердження допису',
      description:
        'Ми надіслали вам лист із кодом поштою {email}. Відправлення може зайняти до однієї хвилини'
    },
    register: {
      title: 'Реєстрація {role}',
    },
    invite: {
      title: 'Ласкаво просимо до Live Bright Connect',
      description: 'Виберіть свою версію профілю'
    }
  },
  notification: {
    title: 'Сповіщення',
    notFound: 'У вас ще немає повідомлень.',
    description:
      'Ви можете переглянути нові програми від Артистів у розділі "Артисти" у своєму профілі'
  },
  loyalty: {
    inputLabel: 'Ваше посилання:',
    registered: 'Зареєстрований',
    followed_link: 'Переданий за посиланням',
    inputDescription:
      'Щоб запросити Артиста, надішліть посилання на реєстрацію.',
    artist: {
      title: 'Запрошення на сайт',
      description:
        'Артист, який завершив реєстрацію вашого посилання, вважається запрошеним.'
    },
    club: {
      title: 'Програма лояльності',
      note: 'Артист, який завершив реєстрацію вашого посилання, вважається запрошеним.',
      description: 'Отримайте Артистів без комісії!',
      text: '👯‍♀ У вас був кастинг, а Артист не підійшов? Хтось завершує договір? Надішліть їй своє особисте посилання.',
      content:
        'Коли Артист зареєстрований за вашим посиланням, вона підраховується вам. 📌 На кожні 5 Артистів ви отримуєте 1 контракт без комісії — за 1 календарний місяць. Навіть якщо Артист обирає інший клуб, вона все одно буде врахована у вашому прилавку.'
    }
  },
  language: {
    title: 'Мови',
    description: 'Виберіть мову платформи',
    options: {
      ru: 'Російська',
      en: 'Англійська',
      uk: 'Українська',
      it: 'Італійська',
      de: 'Німецька',
      tr: 'Турецька',
      es: 'Іспанська'
    }
  },
  profilePage: {
    techSupport: 'Служба догляду',
    privacy: 'Умови та конфіденційність',
    artist: {
      work: 'Робота в клубі',
      infoEditSection: 'Редагування',
      infoAppSection: 'Застосування',
      personalInfo: 'Особиста інформація',
      portfolio: 'Портфоліо',
      invitationAndRequests: 'Заявки та запрошення',
      hideProfile: 'Приховати рахунок',
      loyaltyLink: 'Запросіть друга'
    },
    club: {
      clubInfoSection: 'Клубна інформація',
      artistsSection: 'Артисти',
      artistHiring: 'Набір Артистів',
      loyaltyProgram: 'Програма лояльності',
      editingSection: 'Редагування',
      clubInfo: 'Особиста інформація',
      conditions: 'Умови',
      approvedArtists: 'Затверджені Артисти',
      requestsAndInvitations: 'Заявки та запрошення',
      applicationSection: 'Застосування'
    }
  },
  portfolioPage: {
    title: 'Портфоліо',
    warnNotPublished:
      'Резюме не опубліковано. Заповніть портфоліо, щоб опублікувати резюме.',
    warnfillPortfolio: 'Заповніть портфоліо',
    warnf: 'Заповніть портфоліо',
    warnFillSection: 'Заповніть цей розділ, щоб збільшити шанси на запрошення.'
  },
  profileInfo: {
    club: {
      title: 'Інфо'
    },
    artist: {
      title: 'Інфо'
    }
  },
  clubTerms: {
    title: 'Умови',
    description:
      'Спробуйте повністю заповнити всі кроки. Привабливість реклами для Артистів залежить від цього. Зверніться за допомогою, якщо виникають труднощі.',
    progressSteps: {
      schedule: 'Графік роботи клубу',
      contractTerms:
        'Мінімальний контракт, графік Артистів, квитки, трансфер з аеропорту',
      payments:
        'Виплати: Ставка, гарантія, фол, Поплс, Гу-ходо, Депозит, Показ, Чай, Курс, Божевільне меню',
      workConditions: 'Тип споживача. Хореограф. Фотосесії. Пілони. Кількість',
      housing: 'Інформація про житло. Фото.',
      penalties: 'Штрафна сітка',
      photo: 'Фото клубу',
      video: 'Клубне відео'
    }
  },
  clubEmployers: {
    title: 'Затверджені Артисти',
    tabs: {
      pending: 'В очікуванні',
      onContract: 'За договором'
    }
  },
  requestAndInvitation: {
    title: 'Заявки та запрошення'
  },
  onboarding: {
    club: {
      schedule: {
        title: 'Клубні години',
        popups: {
          title: 'Години роботи'
        },
        changeAllWorkTimes: 'Змініть усі години роботи'
      },
      contractTerms: {
        title: 'Умови праці в клубі',
        form: {
          minimalContractTerm: {
            label: 'Мінімальний термін контракту',
            unit: 'Тиждень'
          },
          artistsSchedule: {
            label: 'Графік Артистів'
          }
        }
      },
      payments: {
        title: 'Виплати',
        rateFieldDescription:
          'Якщо у вас є ставка з одним числом, заповніть лише одне з вхідних полів'
      },
      workConditions: {
        title: 'Умови праці в клубі',
        form: {
          noExperienceEmployment: 'Працевлаштування Артистів без досвіду',
          additionalInfo: {
            label: 'Додаткова інформація про клуб',
            placeholder:
              'Ви можете писати про акції чи бонуси у своєму клубі чи іншу інформацію, яка буде цікавою для Артистів',
            description: 'Введіть щонайменше 100 символів'
          }
        },
        popups: {
          dressCode: {
            enterDressCodeElement: 'Введіть елемент коду коду',
            description:
              'Виберіть дрес-код для Артистів у вашому клубі. Додайте відсутні позиції.'
          }
        }
      },
      housing: {
        title: 'Інформація про житло'
      },
      penalties: {
        title: 'Штраф',
        description:
          'Додайте свою позицію, якщо ви не знайшли їх у наданому списку'
      },
      photo: {
        title: 'Фото клубу',
        description:
          'Завантажте фотографії клубу. Ви можете внести зміни пізніше',
        options: {
          hallNoGuests: 'Фото порожнього залу',
          hallWithGuests: 'Фото залу з гостями',
          privateRooms: 'Фото приватних номерів',
          scene: 'Фото сцени'
        }
      },
      video: {
        title: 'Клубне відео',
        description: 'Завантажте клубне відео. Ви можете внести зміни пізніше',
        options: {
          ClubTour: 'Відео порожньої зали',
          EventVideo: 'Відео зал з гостями',
          WorkingHours: 'Відео сцени'
        }
      }
    },
    artist: {
      work: {
        title: 'Досвід у клубах',
        addWorkPlace: 'Додайте місце роботи',
        notHaveWorkExperience: 'Продовжуйте без досвіду'
      },
      language: {
        title: 'Мови',
        languageProfinience: 'Боулінг іноземні мови'
      },
      parametres: {
        title: 'Параметри'
      },
      about: {
        title: 'Про себе',
        description: 'Напишіть про себе, що буде цікаво для клубу',
        textAreaDescription: 'Введіть щонайменше 100 символів',
        textAreaPlaceholder: 'Увійти'
      },
      video: {
        title: 'Відео',
        videoForHostesVacancy: '2. Завантажте відео накопичувач',
        videoForGogoVacancy:
          '1. Завантажте відео, як ви танцюєте для танцюриста вакансії та йдіть'
      },
      photo: {
        title: 'Фото',
        description:
          'Завантажте фотографії. Фотографії повинні бути без фільтрів та Photoshop.',
        FaceNoMakeup: 'Модель - це обличчя без макіяжу.',
        FaceWithMakeup: 'Обличчя / make -up.',
        FreePose: 'Фото модель у безкоштовній позі.',
        FullBodyOnHeels: 'Фотографії моделі на повній висоті на підборах.',
        LingerieOrSwimsuit: 'Фото модель у купальнику',
        selectMainPhoto: 'Виберіть основну фотографію'
      }
    }
  },
  workInteraction: {
    club: {
      artistHaveContract: 'Артист уже працює в клубі',
      incompleted:
        'Щоб надіслати запрошення, ви повинні заповнити свій профіль на 100%.'
    },
    artist: {
      weCanRequestLastWorkDate:
        'Запитайте дату завершення контракту в клубу.',
      clubSetLastWorkDate:
        'Клуб встановив вашу останню дату роботи в цьому клубі.',
      clubNotHiring:
        'Ви не можете надіслати запит, оскільки клуб не відкрив набір Артистів.',
      pendingRequest:
        'Ви не можете надіслати більше одного запиту протягом 48 годин.',
      haveContract:
        'Ви не можете надіслати запит, оскільки у вас є поточний договір.',
      hidden:
        'Ви не можете надіслати запит, оскільки ваш профіль прихований з пошуку.',
      incompleted:
        'Ви не можете надіслати запит, оскільки ви не заповнили профіль повністю.'
    }
  },
  notFoundWorkItem: {
    title: 'Це запрошення або прохання більше не існує.',
    description:
      'Ми шкодуємо, але сторінок не існує. Будь ласка, зайдіть у Вагіалі.'
  },
  notFoundCurrentWork: {
    title: 'Активний договір',
    description:
      'На даний момент у вас немає активного контракту, перейдіть на сторінку пошуку та надішліть заявку в клуб, щоб розпочати контракт.'
  },
  clubFullProfile: {
    clubVideo: 'Клубне відео',
    clubPhoto: 'Фото клубу',
    clubHousingPhoto: 'Фото житла',
    minimalContractDuration: 'Мінімальний контракт',
    artistWorkSchedule: 'Графік роботи',
    paymentFrequescyMessage: 'Виплати Артисту за споживання — 1 раз у'
  },
  privacyPolicy: {
    title: 'Угода користувача та політика конфіденційності'
  },
  chat: {
    requestSupport: {
      inviteManagerInChat: 'Запросіть менеджера до спілкування',
      managerIsInChat: 'Чат менеджер',
      manageRequestPending: 'Незабаром менеджер буде доданий'
    },
    admin: {
      assistanceProvided: 'Надається допомога',
      openDirectChat: 'Відкрити особистий чат',
      openWhatsApp: 'Відкрити WhatsApp',
      phoneNumberNotAvailable: 'Номер телефону недоступний'
    }
  }
};

